module.exports = __webpack_public_path__ + "assets/img/222.d72037b5.jpg";